import { render, staticRenderFns } from "./story_publications.vue?vue&type=template&id=249e5223&lang=pug"
import script from "./story_publications.vue?vue&type=script&lang=js"
export * from "./story_publications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports